/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    ScheduledRequest,
    ScheduledRequestFromJSON,
    ScheduledRequestFromJSONTyped,
    ScheduledRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ScheduledRequestResponse
 */
export interface ScheduledRequestResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof ScheduledRequestResponse
     */
    msg: string;
    /**
     * 
     * @type {ScheduledRequest}
     * @memberof ScheduledRequestResponse
     */
    entry: ScheduledRequest;
}

export function ScheduledRequestResponseFromJSON(json: any): ScheduledRequestResponse {
    return ScheduledRequestResponseFromJSONTyped(json, false);
}

export function ScheduledRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledRequestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': ScheduledRequestFromJSON(json['entry']),
    };
}

export function ScheduledRequestResponseToJSON(value?: ScheduledRequestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': ScheduledRequestToJSON(value.entry),
    };
}


